<template>
  <v-app>
    <RbFullPageLoader v-if="isLoading" />
    <template v-else-if="isLoginPage">
      <router-view />
    </template>

    <template v-else>
      <rb-sidebar
        v-model:drawer="drawer"
        :rail="rail"
        @toggle-sidebar="drawer = !drawer"
      />

      <rb-topbar
        :drawer="drawer"
        @toggle-sidebar="drawer = !drawer"
      />

      <v-main class="d-flex flex-column">
        <v-container fluid class="flex-grow-1 ma-0 pa-1 bg-grey">
          <router-view />
        </v-container>
        <ThemeSettings />
      </v-main>
    </template>

    <!-- Global components -->
    <RbGlobalLoader />
    <RbNotification />
    <RbConfirmPopup />
  </v-app>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "App",

  components: {
    ThemeSettings: defineAsyncComponent(() => import("@/shared/components/ThemeSettings.vue")),
    RbNotification: defineAsyncComponent(() => import("@/shared/components/alerts/RbNotification.vue")),
    RbConfirmPopup: defineAsyncComponent(() => import("@/shared/components/alerts/RbConfirm.vue")),
    RbGlobalLoader: defineAsyncComponent(() => import("@/shared/components/loader/GlobalLoader.vue")),
    RbFullPageLoader: defineAsyncComponent(() => import("@/shared/components/loader/FullPageLoader.vue")),
  },

  data() {
    return {
      drawer: true,
      rail: false,
    };
  },

  computed: {
    isLoginPage() {
      return this.$route.name === "Login";
    },
    isLoading() {
      return !this.$auth && !this.isLoginPage;
    },
  }
};
</script>

<style>
.v-application {
  transition: background-color 0.3s ease, color 0.3s ease;
}
</style>